module.exports = __webpack_public_path__ + "img/38_3.79793a06.png";